import { useState, useEffect } from "react";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import { toast } from "react-toastify";

import Tooltip from "@mui/material/Tooltip";
import { DeleteOutline } from "@mui/icons-material";

import "./depositsClaimsWithdrawals.css";
import HiddenBlock from "../../../components/crudSql/hiddenBlock/HiddenBlock";
import { mysqlDateHm } from "../../../components/common/date";

export default function DepositsClaimsWithdrawals(props) {
  const [vaultWithdrawals, setVaultWithdrawals] = useState([]);

  useEffect(() => {
    // Выводы денег с выбранного кошелька
    const getVaultWithdrawals = () => {
      const apiUrl = "/vault/withdrawals";
      const url =
        process.env.REACT_APP_CRUD_SRV +
        apiUrl +
        "?assetId=" +
        props.assetId +
        "&wallet=" +
        props.wallet +
        "&auth=" +
        props.userAuthWallet +
        "&cs=" +
        sha256(
          apiUrl +
            // assetId +
            props.wallet +
            props.userAuthWallet +
            process.env.REACT_APP_SECRET
        ).toString();
      if (process.env.REACT_APP_CLG_AXIOS_URLS == 1) console.log(url);
      Axios.get(
        url
        // bcrypt(userAuthWallet, process.env.REACT_APP_SECRET)
      ).then((res) => {
        console.log("/vault/withdrawals? =", res.data);
        if (1 && res.data.status == 200) setVaultWithdrawals(res.data.response);
      });
    };

    if (1 && props.wallet) getVaultWithdrawals();
  }, [props.wallet]);

  function handleRmClick(e, row) {
    // console.log("del", row);

    const apiUrl = "/delete/depositClaimWithdraw";
    const url = process.env.REACT_APP_CRUD_SRV + apiUrl;
    if (process.env.REACT_APP_CLG_AXIOS_URLS == 1) console.log(url);
    Axios.post(url, {
      itemType: row.typ,
      itemId: row.id,
      wallet: props.wallet,
      auth: props.userAuthWallet,
      cs: sha256(
        apiUrl +
          row.typ +
          row.id +
          props.wallet +
          props.userAuthWallet +
          process.env.REACT_APP_SECRET
      ).toString(),
    }).then((res) => {
      console.log(apiUrl + "? =", res.data);
      if (1 && res.data.status == 200) {
        toast.success(row.typ + " has been deleted successfully.");
        // удаляем строку из вывода
        setVaultWithdrawals((prev) =>
          prev.filter((item) => !(item.typ == row.typ && item.id == row.id))
        );
      } else toast.error("Error deleting " + row.typ);
    });
  }

  return (
    <>
      {vaultWithdrawals.length > 0 && (
        <HiddenBlock title="History" className="underButtonHiddenBlock">
          <table>
            <thead>
              <tr>
                <th>Time</th>
                <th>Action</th>
                <th>Token</th>
                <th>Balance change</th>
                <th>Balance change in USD</th>
                <th>Remark</th>
              </tr>
            </thead>
            <tbody>
              {vaultWithdrawals.map((row, i) => (
                <tr key={i}>
                  <td>{mysqlDateHm(row.dt)}</td>
                  <td>{row.typ}</td>
                  <td>{row.tokenAbbr}</td>
                  <td>{row.balanceChange}</td>
                  <td>
                    {row.balanceChangeUsd}
                    <span className="sub historyCurrency">$</span>
                  </td>
                  <td>{row.remark}</td>
                  <td className="rmBtn">
                    <Tooltip title={"Delete this " + row.typ + " forever"}>
                      <DeleteOutline
                        onClick={(e) =>
                          handleRmClick(e, { typ: row.typ, id: row.id })
                        }
                      />
                    </Tooltip>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </HiddenBlock>
      )}
    </>
  );
}
